import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Lightweight polling hook used by anything that needs to know whether the
 * platform is in Test Mode (default: true). Polls every 8s so the TopNav
 * badge reflects toggles done elsewhere in the app.
 */
export default function useSettings(pollMs = 8000) {
    const [settings, setSettings] = useState(null);
    useEffect(() => {
        let alive = true;
        const load = async () => {
            try {
                const { data } = await api.get("/settings");
                if (alive) setSettings(data);
            } catch {
                /* ignore — user may not be logged in yet */
            }
        };
        load();
        const t = setInterval(load, pollMs);
        return () => { alive = false; clearInterval(t); };
    }, [pollMs]);
    return settings;
}
